module.exports = __webpack_public_path__ + "img/template.33bc9004.png";